module.exports = __webpack_public_path__ + "img/google-photos.1095c1a3.svg";